export default __webpack_public_path__ + "static/media/collapse.225a2045.svg";